module.exports = __webpack_public_path__ + "img/14.5718a689.png";